
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 3a1.8 1.8 0 00-1.8 1.8v5.4H4.8a1.8 1.8 0 000 3.6h5.4v5.4a1.8 1.8 0 003.6 0v-5.4h5.4a1.8 1.8 0 000-3.6h-5.4V4.8A1.8 1.8 0 0012 3z","fill":"#282E3E"}})])
          )
        }
      }
    